import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import FormCard from '../../../shared/components/custom/FormCard';
import { formatDate, formatDateTime } from '../../../util/date-and-time';
import { partial } from '../../../util/translation/translation';

const p = partial('chat');

// Users the club blocked from writing in its chats (they can still read),
// or, with its own `title`, from something else such as bidding
const BlockedChatUsersCard = ({
  blockedUsers,
  onUnblock,
  title = p('blockedUsers'),
}) => (
  <FormCard
    title={title}
    bodyClassName="form-card__body--flush"
    className="mb-3"
  >
    <Table responsive striped className="table--roomy table--stack">
      <thead>
        <tr>
          <th>{p('user')}</th>
          <th>{p('blockedAt')}</th>
          <th>{p('blockedUntil')}</th>
          <th>{p('reason')}</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {blockedUsers.length === 0 ? (
          <tr>
            <td colSpan={5} className="text-muted">
              {p('noBlockedUsers')}
            </td>
          </tr>
        ) : (
          blockedUsers.map((user) => (
            <tr key={user.userId}>
              <td className="table-stack__primary">
                <Link to={`/users/edit/${user.userId}`}>
                  {user.userName || user.userId}
                </Link>
              </td>
              <td data-label={p('blockedAt')}>{formatDate(user.createdAt)}</td>
              <td data-label={p('blockedUntil')}>
                {user.expiresAt
                  ? formatDateTime(user.expiresAt)
                  : p('blockDuration_permanent')}
              </td>
              <td data-label={p('reason')}>{user.reason || '-'}</td>
              <td className="text-right table-stack__actions">
                <Button
                  size="sm"
                  color="secondary"
                  className="mb-0"
                  onClick={() => onUnblock(user.userId)}
                >
                  {p('unblockUser')}
                </Button>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </Table>
  </FormCard>
);

export default BlockedChatUsersCard;
